import React from "react";

import "./Grid.scss";

const GridIcon = ({ active }) => (
  <svg id="Tile" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="parent-grid-icon">
    <g id="Group_10891" data-name="Group 10891" className={active ? "active" : null}>
      <path id="Path_9274" data-name="Path 9274" d="M0,0H32V32H0Z" className="gridcls-1" />
      <g id="Group_10890" data-name="Group 10890" className="gridcls-2">
        <g id="Path_9275" data-name="Path 9275" className="gridcls-5">
          <path d="M8,14.588V8h6.588v6.588Z" className="gridcls-3" />
          <path
            d="M 13.58800029754639 13.58800029754639 L 13.58800029754639 9.000000953674316 L 9.000000953674316 9.000000953674316 L 9.000000953674316 13.58800029754639 L 13.58800029754639 13.58800029754639 M 14.58800029754639 14.58800029754639 L 8.000000953674316 14.58800029754639 L 8.000000953674316 8.000000953674316 L 14.58800029754639 8.000000953674316 L 14.58800029754639 14.58800029754639 Z"
            className="gridcls-4"
          />
        </g>
        <g id="Path_9276" data-name="Path 9276" className="gridcls-5">
          <path d="M17.412,14.588V8H24v6.588Z" className="gridcls-3" />
          <path
            d="M 23.00000190734863 13.58800029754639 L 23.00000190734863 9.000000953674316 L 18.41200065612793 9.000000953674316 L 18.41200065612793 13.58800029754639 L 23.00000190734863 13.58800029754639 M 24.00000190734863 14.58800029754639 L 17.41200065612793 14.58800029754639 L 17.41200065612793 8.000000953674316 L 24.00000190734863 8.000000953674316 L 24.00000190734863 14.58800029754639 Z"
            className="gridcls-4"
          />
        </g>
        <g id="Path_9277" data-name="Path 9277" className="gridcls-5">
          <path d="M17.412,24V17.412H24V24Z" className="gridcls-3" />
          <path
            d="M 23.00000190734863 23.00000190734863 L 23.00000190734863 18.41200065612793 L 18.41200065612793 18.41200065612793 L 18.41200065612793 23.00000190734863 L 23.00000190734863 23.00000190734863 M 24.00000190734863 24.00000190734863 L 17.41200065612793 24.00000190734863 L 17.41200065612793 17.41200065612793 L 24.00000190734863 17.41200065612793 L 24.00000190734863 24.00000190734863 Z"
            className="gridcls-4"
          />
        </g>
        <g id="Path_9278" data-name="Path 9278" className="gridcls-5">
          <path d="M8,24V17.412h6.588V24Z" className="gridcls-3" />
          <path
            d="M 13.58800029754639 23.00000190734863 L 13.58800029754639 18.41200065612793 L 9.000000953674316 18.41200065612793 L 9.000000953674316 23.00000190734863 L 13.58800029754639 23.00000190734863 M 14.58800029754639 24.00000190734863 L 8.000000953674316 24.00000190734863 L 8.000000953674316 17.41200065612793 L 14.58800029754639 17.41200065612793 L 14.58800029754639 24.00000190734863 Z"
            className="gridcls-4"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default GridIcon;
